export default __webpack_public_path__ + "static/media/chat-blue.8eb7591a.svg";